import { render, staticRenderFns } from "./ModuleCard.vue?vue&type=template&id=32e7670e&scoped=true"
import script from "./ModuleCard.vue?vue&type=script&lang=js"
export * from "./ModuleCard.vue?vue&type=script&lang=js"
import style0 from "./ModuleCard.vue?vue&type=style&index=0&id=32e7670e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e7670e",
  null
  
)

export default component.exports